import { render, staticRenderFns } from "./LayoutSidebarUser.vue?vue&type=template&id=9b75c4bc&scoped=true&"
import script from "./LayoutSidebarUser.vue?vue&type=script&lang=js&"
export * from "./LayoutSidebarUser.vue?vue&type=script&lang=js&"
import style0 from "./LayoutSidebarUser.vue?vue&type=style&index=0&id=9b75c4bc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b75c4bc",
  null
  
)

export default component.exports